import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { FilterToolbar } from '@features/toolbarFilter';
import { SortToolbar } from '@features/toolbarSort';
import { orders } from '@features/toolbarSort/types';
import { sortFilterToolbarId } from '..';
import {
  $isFiltersApply,
  filtersForm,
  filtersKey,
  setFilters,
  defaultFilters,
  normalizeStoredFilters,
  sortChanged,
  sortingReadyChanged,
} from '../../../models';
import type { StoredFilters } from '../../../models/filters/types';
import * as Styled from '../styled';

export const SortFilterToolbar = () => {
  const { t } = useTranslation();
  const isFiltersApply = useUnit($isFiltersApply);
  const { initialValues } = useUnit(filtersForm);

  const sortConfig = {
    id: sortFilterToolbarId,
    columns: [
      {
        id: 'updated_at',
        field: t('byUpdateDate'),
      },
      {
        id: 'created_at',
        field: t('byCreatedAt'),
      },
      {
        id: 'planned_date',
        field: t('byPlannedDate'),
      },
      {
        id: 'number',
        field: t('byNumber'),
      },
    ],
    canReset: false,
    default: {
      column: 'created_at',
      order: orders.desc,
    },
  };

  const setFiltersForToolbar = (filters: StoredFilters) => setFilters(filters);

  return (
    <Styled.SortFilterToolbar>
      <SortToolbar
        config={sortConfig}
        outerSortChanged={sortChanged}
        sortingReadyChanged={sortingReadyChanged}
      />

      <FilterToolbar
        config={{ id: filtersKey }}
        filters={initialValues}
        isFilterDefault={!isFiltersApply}
        resetFilters={() => setFilters(defaultFilters)}
        normalizeFilters={(filters) =>
          normalizeStoredFilters(filters as StoredFilters)
        }
        setFiltersOutside={setFiltersForToolbar}
      />
    </Styled.SortFilterToolbar>
  );
};
